import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import documentController from '../../redux/api/documentController';
import { saveAs } from 'file-saver';
import telemetryController from '../../redux/api/tbTelemetryController';
import { toast } from 'react-toastify';

const initialState = {
  documents: [],
  status: 'idle',
};

const parseJwt = (token) => {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const getAllDocument = createAsyncThunk('allDocument', async (data) => {
  const { token } = data;

  const responselistFileId = await telemetryController.getPermission(
    token,
    'USER',
    parseJwt(token).userId
  );
  let listFileId;
  Object.values(responselistFileId).map((item) => {
    if (item['key'] === 'listFileId') listFileId = item.value;
  });

  let queryUrl = '';
  if (listFileId && listFileId.length > 0) {
    listFileId.map(
      (id, idx) => (queryUrl += idx === 0 ? `?fileId=${id}` : `&fileId=${id}`)
    );
  }
  if (queryUrl !== '') {
    const response = await documentController.getAllDocument(queryUrl);
    return response;
  } else {
    return {
      data: [],
    };
  }
});

export const uploadDocument = createAsyncThunk(
  'uploadDocument',
  async (data) => {
    const { token, file, title } = data;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('title', title);

    const response = await documentController.uploadDocument(formData);

    const responselistFileId = await telemetryController.getPermission(
      token,
      'USER',
      parseJwt(token).userId
    );
    let listFileId;
    Object.values(responselistFileId).map((item) => {
      if (item['key'] === 'listFileId') listFileId = item.value;
    });

    const responseSaveFileId = await telemetryController.saveEntityAttributesV2(
      token,
      'USER',
      parseJwt(token).userId,
      {
        listFileId: listFileId
          ? [...listFileId, response.data.id]
          : [response.data.id],
      }
    );
    return responseSaveFileId;
  }
);

export const downloadDocument = createAsyncThunk(
  'downloadDocument',
  async (data) => {
    const { fileId, fileName } = data;
    const response = await documentController.downloadDocument(fileId);

    saveAs(response, fileName);

    return response;
  }
);

export const deleteDocument = createAsyncThunk(
  'deleteDocument',
  async (data) => {
    const { token, fileId } = data;

    const responselistFileId = await telemetryController.getPermission(
      token,
      'USER',
      parseJwt(token).userId
    );
    let listFileId;
    Object.values(responselistFileId).map((item) => {
      if (item['key'] === 'listFileId') listFileId = item.value;
    });

    const newListFileId = listFileId.filter((id) => id !== fileId);

    const responseSaveFileId = await telemetryController.saveEntityAttributesV2(
      token,
      'USER',
      parseJwt(token).userId,
      {
        listFileId: newListFileId,
      }
    );

    await documentController.deleteDocument(fileId);

    return responseSaveFileId;
  }
);

export const documentSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllDocument.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getAllDocument.fulfilled, (state, action) => {
      state.status = 'success';
      state.documents = action.payload;
    });
    builder.addCase(getAllDocument.rejected, (state) => {
      state.status = 'failed';
    });

    builder.addCase(uploadDocument.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(uploadDocument.fulfilled, (state) => {
      state.status = 'idle';
      toast.success('Successfully!');
    });
    builder.addCase(uploadDocument.rejected, (state) => {
      state.status = 'failed';
    });

    builder.addCase(downloadDocument.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(downloadDocument.fulfilled, (state) => {
      state.status = 'idle';
    });
    builder.addCase(downloadDocument.rejected, (state) => {
      state.status = 'failed';
    });

    builder.addCase(deleteDocument.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(deleteDocument.fulfilled, (state) => {
      state.status = 'idle';
      toast.success('Delete Successfully!');
    });
    builder.addCase(deleteDocument.rejected, (state) => {
      state.status = 'failed';
    });
  },
});

export default documentSlice.reducer;

export const allDocument = (state) => state.documents.document;
